import axios from '@/axios.js'
import ot from '../../http/requests/overtime/index.js'
import hr from '../../http/requests/hrms/index.js'
import photoUpload from '../../http/requests/photo/index.js'
export default {
  addOvertime({ commit }, item) {
    return new Promise((resolve, reject) => {
        axios.post('/api/overtime', item)
          .then((response) => {
            commit('ADD_OVERTIME', response.data.data)//Object.assign(item, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  updateOvertime({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.put('/api/overtime', items)
          .then((response) => {            
            //console.log(response.data.data)
            commit('UPDATE_OVERTIME', Object.assign(items, {approversOTs: response.data.data.approversOTs}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllEmployeeOvertime({commit}, payload) {
    return new Promise((resolve, reject) => {
        ot.getAllOvertime(payload.sortBy, payload.sortOrder, payload.pageNumber, payload.pageSize, payload.isApprover)
          .then((response) => {
            commit('GET_ALL_OVERTIME',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllOvertimeType({commit}) {
    return new Promise((resolve, reject) => {
        ot.getAllOvetimeType()
          .then((response) => {
            commit('GET_ALL_OVERTIMETYPE',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  getAllApproversByModule({commit}, item){
      return new Promise((resolve, reject) => {
        hr.getAllApproversByModule(item.module, item.userId)
          .then((response) => {
            commit('GET_ALL_APPROVERS',  response.data.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
  },
  unSubmit({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isSubmitted: items.isSubmitted,
        approverId: items.approverId
      })
        .then((response) => {
          commit('UNSUBMIT_OVERTIME', items.employeeFiledOvertimeId)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onCancelled({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isSubmitted: items.isSubmitted,
        isCancelled: items.isCancelled,
        cancelledOn: items.cancelledOn,
        isRevised: items.isRevised,
        remarks: items.remarks,
        approverId: items.approverId
      })
        .then((response) => {
          commit('CANCELLED_OVERTIME', items)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onRetracked({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        isDraft: items.isDraft,
        isRetracted: items.isRetracted,
        retractedOn: items.retractedOn,
        isApproved: items.isApproved,
        remarks: items.remarks,
        approverId: items.approverId
      })
        .then((response) => {
          commit('RETRACKED_OVERTIME', items)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onApproved({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        isUnread : items.isUnread, 
        isApproved: items.isApproved, 
        approvedOn : items.approvedOn, 
        isRetracted : items.isRetracted, 
        approverId: items.approverId
      })
        .then((response) => {
          commit('APPROVED_OVERTIME', items)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onDenied({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        isUnread : items.isUnread, 
        isDenied: items.isDenied, 
        deniedOn : items.deniedOn, 
        isRetracted : items.isRetracted, 
        comments: items.comments,
        approverId: items.approverId
      })
        .then((response) => {
          commit('DENIED_OVERTIME', items)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
  onRevised({commit}, items) {
    return new Promise((resolve, reject) => {
      axios.patch(`/api/overtime/${items.employeeFiledOvertimeId}`, {
        action: items.action,
        // isDraft: items.isDraft,
        // isSubmitted: items.isSubmitted,
        isUnread : items.isUnread, 
        isRevised: items.isRevised, 
        forRevisionOn : items.forRevisionOn, 
        isRetracted : items.isRetracted, 
        comments: items.comments,
        approverId: items.approverId
      })
        .then((response) => {
          commit('REVISED_OVERTIME', items)//Object.assign(items, {employeeFiledOvertimeId: response.data.data.employeeFiledOvertimeId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
  },
}